module.exports = __webpack_public_path__ + "img/ico-arrow-bottom.486aa281.svg";